<div *ngIf="price >=0" class="flex items-center justify-center whitespace-nowrap">
    <div class="{{styleClass}}">{{ price | currencyConversion }}</div>
</div>
